export default __webpack_public_path__ + "imgs/wx_kf.21da1cf9.png";